(function () {
  const root = document.querySelector('[data-free-gift-floating]');
  if (!root) return;

  const tab = root.querySelector('.free-gift-floating__tab');
  const panel = document.getElementById('FreeGiftPanel');
  const closeBtn = root.querySelector('.free-gift-floating__close');
  const railClose = root.querySelector('[data-free-gift-rail-close]');
  const backdrop = root.querySelector('.free-gift-floating__backdrop');

  if (!tab || !panel) return;

  const setPanelInert = (inert) => {
    if (inert) {
      panel.setAttribute('inert', '');
    } else {
      panel.removeAttribute('inert');
    }
  };

  const setOpen = (open) => {
    root.classList.toggle('is-open', open);
    tab.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    setPanelInert(!open);

    if (backdrop) {
      backdrop.classList.toggle('is-visible', open);
      backdrop.setAttribute('aria-hidden', open ? 'false' : 'true');
    }

    document.body.classList.toggle('free-gift-floating--lock', open);
  };

  tab.addEventListener('click', (e) => {
    e.preventDefault();
    const next = !root.classList.contains('is-open');
    setOpen(next);
  });

  closeBtn?.addEventListener('click', () => setOpen(false));

  railClose?.addEventListener('click', () => setOpen(false));

  backdrop?.addEventListener('click', () => setOpen(false));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && root.classList.contains('is-open')) {
      setOpen(false);
      tab.focus();
    }
  });
})();
